import React from "react";
import LuvitComponent from "LuvitComponent";
import format from "lib/format";
import Dialog from "Components/Fragment/Dialog";
import { getDateTimeString, getCourseDateFormat } from "lib/utils";
import { Button } from "Components/Base/Inputs/Button";
import { navigateToMsTeams } from "domains/programs/functions";
import { GET } from "Common/api";

export default class CourseDetails extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "ActivityCentre");
  }

  async componentWillMount() {
    let coursesInfo = await GET(
      "v1/user/:personalId/courseobjectinfo/:courseObjectId",
      {
        personalId: this.props.personalId,
        courseObjectId: this.props.course.courseId,
      },
    );

    let activities = coursesInfo[0];
    let onlineCourses = coursesInfo[1];
    this.setState({ activities, onlineCourses, ready: true });
  }

  renderActivities() {
    const { activityId } = this.props;
    const fromProgramView = activityId;

    const fromWhereQueryString = fromProgramView
      ? `&prid=${activityId}&m=pr`
      : "&m=ml";

    let activities = this.state.activities.map((activity) => {
      const { activityId } = activity;
      const displayDates =
        activity.startDate && activity.endDate !== "0001-01-01T00:00:00";

      const startdateFormat = getCourseDateFormat(activity.startDate);
      const enddateFormat = getCourseDateFormat(activity.endDate);

      return (
        <div key={activityId}>
          <h3>{activity.activityTitle}</h3>
          {!activity.isPostRegistration && displayDates && (
            <>
              <div className="flex">
                <div>{this.l("startdate") + ": "}&nbsp;</div>
                <div>
                  {getDateTimeString(activity.startDate, startdateFormat)}
                </div>
              </div>
              <div className="flex margin-t-5">
                <div>{this.l("enddate") + ": "}&nbsp;</div>
                <div>{getDateTimeString(activity.endDate, enddateFormat)}</div>
              </div>
            </>
          )}

          <div className="flex margin-t-5">
            <div>{this.l("location") + ": "}&nbsp;</div>
            <div>{activity.location}</div>
          </div>
          {activity.linkToMeeting && (
            <div className="flex margin-t-5">
              <div>{this.l("linktomeeting") + ": "}&nbsp;</div>
              <div>
                <a
                  href={
                    activity.linkToMeeting.startsWith("http://") ||
                    activity.linkToMeeting.startsWith("https://")
                      ? activity.linkToMeeting
                      : `//${activity.linkToMeeting}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {activity.linkToMeeting}
                </a>
              </div>
            </div>
          )}

          <div className="flex margin-t-5">
            <div>{this.l("practicalinformation") + ": "}&nbsp;</div>
            <div>{activity.locationInfo}</div>
          </div>
          <div className="flex margin-t-5">
            <div>{this.l("registrationStatus") + ": "}&nbsp;</div>
            <div>
              {activity.isConfirmed === 1
                ? this.l("confirmed")
                : this.l("notConfirmed")}
            </div>
          </div>
          <br />
          {!this.props.isManagerOrAdmin && (
            <div>
              {!activity.isPostRegistration && (
                <a
                  href={
                    format.url("/Activities/ActivityApplication.aspx") +
                    "?id=" +
                    activity.activityID +
                    fromWhereQueryString
                  }
                >
                  {this.l("showapplicationform")}{" "}
                </a>
              )}
              <br />
              {activity.connectedToMSTeams && (
                <div className="flex flex-end">
                  <Button
                    color="secondary"
                    onClick={() => navigateToMsTeams(activity.activityID)}
                    label={this.l("toMSTeams")}
                  />
                </div>
              )}
            </div>
          )}

          <div>{this.renderOnlineCourses(activity.activityID)}</div>
          <br />
        </div>
      );
    });

    return activities;
  }

  renderOnlineCourses(activityId) {
    let courses = this.state.onlineCourses.filter(function (c) {
      return c.activityID === activityId;
    });

    return this.renderOnlineCoursesInternal(courses);
  }

  renderGeneralOnlineCourses() {
    let courses = this.state.onlineCourses.filter(function (c) {
      return !c.activityID;
    });

    return this.renderOnlineCoursesInternal(courses);
  }

  renderOnlineCoursesInternal(courses) {
    courses = courses.filter(
      (course, index, self) =>
        index === self.findIndex((c) => c.courseID === course.courseID),
    );

    if (this.props.isManagerOrAdmin) {
      return courses.map((c) => (
        <div key={c.courseID}>{this.l("onlinecourse") + ": " + c.title}</div>
      ));
    } else {
      return courses.map((c) => (
        <div key={c.courseID}>
          {this.l("entercoursesession") + ": "}
          <a
            href={
              format.url("/education/entercourse.aspx") +
              "?from=ml&courseid=" +
              c.courseID
            }
          >
            {c.title}
          </a>
        </div>
      ));
    }
  }

  render() {
    if (!this.state || !this.state.ready) return <div />;
    let basePath = document.location.pathname;
    basePath = basePath.replace("activitycentre/activitycentre.aspx", "");
    const { activityId } = this.props;
    const fromProgramView = activityId;

    const fromWhereQueryString = fromProgramView
      ? `&prid=${activityId}&m=pr`
      : "&m=ml";

    const courseId =
      this.props.course.courseObjectId || this.props.course.courseId;

    return (
      <Dialog
        title={this.props.course.title}
        text={
          <div>
            <br />
            <a
              href={`${basePath}activities/ActivityDetails.aspx?inapp=1&id=${courseId}`}
            >
              {this.l("showInCourseCalalogue")}
            </a>
            {this.renderGeneralOnlineCourses()}
            {this.renderActivities()}
          </div>
        }
        onClose={this.props.closeDetails}
        open={true}
        maxWidth="md"
        fullWidth
        cancelText={this.l("close")}
        disableEnforceFocus={
          this.state.editHelpTextCustom || this.state.editHelpTextSystem
        }
      />
    );
  }
}
